import { Class, MessageGroup } from '@/plugins/api'
import { map, rangeRight } from 'lodash-es'
export default {
  namespaced: true,
  state: {
    classes: {},
    ownClassTeacherData: [],
    classesData: [],
    pageText: '',
    itemsPerPage: 10,
    classSearchParams: {},
    totalItems: 0,
    loading: false
  },
  actions: {
    async searchClasses({ commit, state, dispatch }, query) {
      const classSearchParams = {
        _limit: state.itemsPerPage,
        ...query
      }

      commit('changeState', { classSearchParams })
      dispatch('requestPageSettings', {})
    },
    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage }) {
      state.loading = true
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage
      if (state.classSearchParams) {
        const classSearchParams = {
          ...state.classSearchParams,
          type: 'coreCurriculum',
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
          _sort: 'grade.gradeNumber:ASC,title:asc',
          status: 'running'
        }
        const [totalItems, classesData] = await Promise.all([
          Class.count(classSearchParams),
          Class.search(classSearchParams)
        ])

        if (totalItems > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            classesData,
            totalItems,
            itemsPerPage,
            classSearchParams
          })

          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > totalItems || pageStop === -1 ? totalItems : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${totalItems}`
          commit('changeState', { pageText })
        } else {
          var pages = rangeRight(1, page)
          for (let index = 0; index < pages; index++) {
            const selectedPage = pages[index]
            if (totalItems > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }
      state.loading = false
    },

    async searchOwnClassTeacher({ commit }, query) {
      const { classId, grade } = query
      const classQuery = { grade, id: classId }
      var data = await Class.fetch(classQuery)
      if (query.teacher) {
        data = data.filter(item => map(item.headTeachers, 'id').includes(query.teacher.id))
        data.forEach(d => {
          d.headTeachers = [query.teacher]
        })
      }
      commit('setOwnClassTeacherData', data)
    },
    async updateClass({ commit }, { id, ...classData }) {
      const c = await Class.update(id, classData)
      commit('updateClass', c)
      return c
    },
    async updateMessageGroup(_, data) {
      const teacherMessageGroups = await MessageGroup.fetch({
        class: data.classData.id,
        type: 'teacher',
        _limit: -1
      })

      for (const messageGroup of teacherMessageGroups) {
        const groupData = {}
        groupData.name = 'GVCN ' + data.classData.headTeachers.map(t => t.name).join(', ')
        await MessageGroup.update(messageGroup.id, groupData)
      }
    },
    async fetchClasses(_, options) {
      const classes = await Class.fetch(options)
      return classes
    }
  },
  mutations: {
    updateClass(state, classData) {
      state.classesData = state.classesData.map(g => {
        if (classData.id === g.id) return classData
        else return g
      })
    },
    setOwnClassTeacherData(state, classes) {
      state.loading = true
      var temp = []
      classes.forEach(item => {
        if (item.headTeachers.length === 0) {
          temp = [...temp, { ...item, generatedId: item.id }]
          return
        }
        item.headTeachers.forEach(teacher => {
          temp = [...temp, { ...item, generatedId: item.id + teacher.id, headTeacher: teacher }]
        })
      })
      state.ownClassTeacherData = temp
      state.loading = false
    }
  }
}
